export default __webpack_public_path__ + "static/media/education.ff5b0bb6.svg";